import { render } from "./ListeLivreurPage.vue?vue&type=template&id=03e808bb&ts=true"
import script from "./ListeLivreurPage.vue?vue&type=script&lang=ts"
export * from "./ListeLivreurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__